import { render, staticRenderFns } from "./shop-product-shippings.vue?vue&type=template&id=11b45dc0&"
import script from "./shop-product-shippings.vue?vue&type=script&lang=js&"
export * from "./shop-product-shippings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports